import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { trackEvent } from "../utils/analytics";

function Navbar({ basePath = '' }) {
    const { t } = useTranslation();
    const [scrolled, setScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();
    const isProjectDetail = location.pathname.includes('/proyecto/');

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

    return (
        <nav className={`navbar ${scrolled || isProjectDetail ? 'scrolled' : ''}`}>
            <Link to={`${basePath}/#herohome`} className="logo">
                <img src={process.env.PUBLIC_URL + '/sources/logo/logo3.webp'} alt="MCE Logo" />
            </Link>

            <button className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Menu">
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </button>

            <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
                <Link to={`${basePath}/#projects`} onClick={() => setIsMobileMenuOpen(false)}>{t('nav.projects')}</Link>
                <Link to={`${basePath}/#about`} onClick={() => setIsMobileMenuOpen(false)}>{t('nav.about')}</Link>
                <Link to={`${basePath}/#blog`} onClick={() => setIsMobileMenuOpen(false)}>{t('nav.blog')}</Link>
                <Link to={`${basePath}/#contact`} onClick={() => setIsMobileMenuOpen(false)}>{t('nav.contact')}</Link>
                <Link to={`${basePath}/inversion`} className="mobile-only" onClick={() => setIsMobileMenuOpen(false)}>{t('nav.inversion')}</Link>
            </div>

            <div className="nav-contact">
                <Link to={`${basePath}/inversion/#hero`} onClick={() =>
                    trackEvent({
                        category: "Navbar",
                        action: "click_inversion_nav",
                        label: "Navbar",
                    })
                }>{t('nav.inversion')}</Link>
            </div>
        </nav>
    );
}

export default Navbar;
